/*
 * Copyright © 2021 EPAM Systems, Inc. All Rights Reserved. All information contained herein is, and remains the
 * property of EPAM Systems, Inc. and/or its suppliers and is protected by international intellectual
 * property law. Dissemination of this information or reproduction of this material is strictly forbidden,
 * unless prior written permission is obtained from EPAM Systems, Inc
 */

import lodeLogo from './assets/images/logo_lode.jpeg';
import hrzntLogo from './assets/images/logo_hrznt.png';
import aclinicaLogo from './assets/images/logo_aclinica.png';
import tmgrphLogo from './assets/images/logo_tmgrph.png';
import sizLogo from './assets/images/logo_siz.jpeg';
import lubimydoctorLogo from './assets/images/logo_lubimydoctor.png';

export const DOMAIN = 'aibolit-qa2.epm-aimd.projects.epam.com';
export const DOC_DOMAIN = 'aibolit.by';
// export const WEB_APP_URL = `https://aibolitmd-mma.web.app`;
export const WEB_APP_URL = `https://aibolit-qa.web.app`;
export const WMA_LINK = 'https://link.aibolit.md/l/mma';
export const MMA_LINK = 'https://link.aibolit.md/l/mma';
export const clinicsData = {
    sizg: {
        baseUrl: `https://${DOMAIN}/api/v2/public/booking/semyazdorovie-gomel`,
        providerCode: 'semyazdorovie-gomel',
        logo: sizLogo,
        serviceBooking: false,
        allowDeepLink: true,
        allowLinkToBumba: true,
        // linkToBumba: 'https://f-med.by/',
        linkToBumba: 'https://aimd-mcw-qa.web.app/siz.html',
        // linkToBumba: 'https://localhost:3000/siz.html',
        downloadPdf: true,
        allowDoctorBookmark: true,
        allowMmaLink: false,
        mcName: 'МЦ Семья и Здоровье',
    },
    lubdm: {
        baseUrl: `https://${DOMAIN}/api/v2/public/booking/lubimydoctor-minsk`,
        providerCode: 'lubimydoctor-minsk',
        logo: lubimydoctorLogo,
        serviceBooking: false,
        allowDeepLink: true,
        downloadPdf: true,
        allowMwaLink: true,
        mcName: 'МЦ Любимый Доктор',
    },
    lodem: {
        baseUrl: `https://${DOMAIN}/api/v2/public/booking/lode-minsk`,
        providerCode: 'lode-minsk',
        logo: lodeLogo,
        serviceBooking: false,
        allowDeepLink: true,
        downloadPdf: true,
        allowMwaLink: true,
        mcName: 'МЦ ЛОДЭ',
    },
    lodeg: {
        baseUrl: `https://${DOMAIN}/api/v2/public/booking/lode-grodno`,
        providerCode: 'lode-grodno',
        logo: lodeLogo,
        serviceBooking: false,
        allowDeepLink: true,
        downloadPdf: true,
        allowMwaLink: true,
        mcName: 'МЦ ЛОДЭ',
    },
    lodeb: {
        baseUrl: `https://${DOMAIN}/api/v2/public/booking/lode-brest`,
        providerCode: 'lode-brest',
        logo: lodeLogo,
        mcName: 'МЦ ЛОДЭ',
        serviceBooking: false,
        allowDeepLink: true,
        downloadPdf: true,
        allowMwaLink: true,
    },
    hrzntm: {
        baseUrl: `https://${DOMAIN}/api/v2/public/booking/horizont2-minsk`,
        providerCode: 'horizont2-minsk',
        logo: hrzntLogo,
        serviceBooking: false,
        allowDeepLink: true,
        downloadPdf: true,
        allowMwaLink: true,
        allowMmaLink: true,
        mcName: 'МЦ Горизонт',
    },
    tmgrphm: {
        baseUrl: `https://${DOMAIN}/api/v2/public/booking/tomography-minsk`,
        providerCode: 'tomography-minsk',
        logo: tmgrphLogo,
        serviceBooking: true,
        allowDeepLink: true,
        downloadPdf: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: true,
        // linkToBumba: 'https://mrt.by/',
        linkToBumba: 'https://aimd-mcw-tomography-qa.web.app/tomography.html',
        // linkToBumba: 'https://localhost:3000/tomography.html',
        allowMmaLink: true,
        mcName: 'МЦ Томография',
        consentsEnabled: true,
    },
    tmgrphm2: {
        baseUrl: `https://${DOMAIN}/api/v2/public/booking/tomography-minsk`,
        providerCode: 'tomography-minsk',
        logo: tmgrphLogo,
        serviceBooking: false,
        allowDeepLink: true,
        downloadPdf: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: true,
        // linkToBumba: 'https://mrt.by/',
        linkToBumba: 'https://aimd-mcw-tomography-qa.web.app/tomography.html',
        // linkToBumba: 'https://localhost:3000/tomography.html',
        allowMmaLink: true,
        mcName: 'МЦ Томография',
    },
    tmgrphm3: {
        baseUrl: `https://${DOMAIN}/api/v2/public/booking/tomography-minsk`,
        providerCode: 'tomography-minsk',
        logo: tmgrphLogo,
        serviceBooking: false,
        allowDeepLink: true,
        downloadPdf: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: true,
        // linkToBumba: 'https://mrt.by/',
        linkToBumba: 'https://aimd-mcw-tomography-qa.web.app/tomography.html',
        // linkToBumba: 'https://localhost:3000/tomography.html',
        allowMmaLink: true,
        mcName: 'МЦ Томография',
    },
    aclnm: {
        baseUrl: `https://${DOMAIN}/api/v2/public/booking/aclinica-mogilev`,
        providerCode: 'aclinica-mogilevl',
        logo: aclinicaLogo,
        serviceBooking: false,
        allowDeepLink: true,
        downloadPdf: true,
        mcName: 'МЦ А-клиника',
    },
};
